import EventSection from '../sections/common/EventSection';
import Fun from '../sections/Fun';
import Zones from '../sections/Zones';
import Recap2024 from '../sections/home-page/Recap2024';
import EventsFullScreenCarousel from '../sections/common/FeaturedEvents';
import UpcomingEvents from '../sections/UpcomingEvents';
import RiyadhSeason2025 from '../sections/home-page/RiyadhSeason2025';
import RecommendedEvents from '../sections/RecommendedEvents';
import Guide from '../sections/Guide';
import Intro from '../Intro';

import HeroSection from '../sections/home-page/Hero';
import LaylatAlomr from '../sections/home-page/Laylat-Alomr';
import type { WebSection } from '@wbk/contentful/api';

type Props = {
  section: WebSection;
  introFinished: boolean;
  setIntroFinished: (finished: boolean) => void;
};

const HomepageSections = ({ section, introFinished, setIntroFinished }: Props) => {
  switch (section.renderType) {
    case 'announcement':
      return (
        <Intro
          key={`intro-${section.id}`}
          // title={(section as WebSection).title}
          videoSrc={(section as WebSection)?.sectionBackground?.url || ''}
          setIntroFinished={(finished: boolean) => {
            setIntroFinished?.(finished);
          }}
        />
      );

    case 'hero':
      return <HeroSection introFinished={introFinished} section={section} />;
    case 'numbered-carousel':
      return <LaylatAlomr section={section} />;
    case 'recap':
      return <Recap2024 section={section} />;
    case 'spotlight':
      return <Guide section={section} />;
    case 'cards-grid':
      return <EventSection section={section} />;

    default:
      break;
  }

  const type = section.contentCollection?.items?.[0]?.__typename;

  switch (type) {
    case 'Zone':
      return <Zones section={section} />;
    case 'WebCard':
      return section.renderType === 'fullwidth-carousel' ? (
        <RiyadhSeason2025 section={section} />
      ) : section.renderType === 'whats-new' ? (
        <UpcomingEvents section={section} />
      ) : null;
    case 'Event':
    case 'Experience':
    case 'Shows':
    case 'Restaurant':
    case 'Package':
      return section.renderType === 'fullwidth-carousel' ? (
        <EventsFullScreenCarousel section={section} />
      ) : section.renderType === 'carousel' ? (
        <EventSection section={section} />
      ) : null;
    case 'Category':
      return <Fun section={section} />;

    default:
      return <RecommendedEvents section={section} />;
  }
};

export default HomepageSections;
